import * as React from "react";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import { Fonts } from "source/app/presentation/Shared/Styles/SharedStyles";
import { QuickJournalToggleIcon } from "../QuickJournalToggle/QuickJournalToggle";

export function BottomRightDashboard({
    displayLarge,
}: {
    displayLarge: boolean;
}) {
    return (
        <span
            {...Style(`bottomRightDashboard`, {
                zIndex: 1,
                display: "inline-flex",
                flexDirection: "column",
                alignItems: "center",
                transform: "translateY(-8px)",
                ...Fonts.iMFell,
                background: "rgba(0,0,0,0.14)",
                backdropFilter: "blur(2px)",
                WebkitBackdropFilter: "blur(2px)",
                padding: "4px 2px 4px 2px",
                borderRadius: "3px",
            })}
        >
            <QuickJournalToggleIcon showWhen={!displayLarge} />
        </span>
    );
}
